export default "__VITE_ASSET__DEXQuR0F__"